import React, { useState } from "react";
import { Button, ToggleButton, ToggleButtonGroup } from 'react-bootstrap'

function InputBoxes(props) {
    const [numInputs, setNumInputs] = useState(1);
    const [inputValues, setInputValues] = useState(Array.from({ length: numInputs }, () => ""));
    const [hasError, setHasError] = useState(false);
    const [disableSwitchFix, setDisableSwitchFix] = useState(false) //if swtiching from inclusions to exclusions, messes  stuff up - reset form first

    const inputElements = inputValues.map((value, i) => (
        <input
            key={i}
            type="text"
            value={value}
            style={{ width: '250px' }} // apply fixed width
            onChange={(e) => {
                const newInputValues = [...inputValues];
                newInputValues[i] = e.target.value;
                setInputValues(newInputValues);
            }}
        />
    ));

    const addInputBoxes = () => {
        setNumInputs(numInputs + 1);
        setInputValues([...inputValues, ""]);
        console.log(inputValues)
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (inputValues.some(value => value === "")) {
            setHasError(true);
        } else {
            setHasError(false);
            props.setExclusions(inputValues);
        }
        setDisableSwitchFix(true)
    };

    const resetForm = () => {
        setInputValues([])
        setHasError(false)
        setDisableSwitchFix(false)
        props.setExclusions([]);
        props.setIsBadStockBool(false)
    }

    return (
        <form onSubmit={handleSubmit}>
            {hasError && <p style={{ color: "red" }}>Please fill in all input boxes</p>}
            <div>Enter any inclusions/exclusions (accepts regex)</div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {inputElements}
            </div>
            <label>
                <ToggleButtonGroup
                    type="radio"
                    name="options"
                    value={props.isInclusion}
                    onChange={() => props.setIsInclusion(!props.isInclusion)}
                    className="mb-3"

                >
                    <ToggleButton disabled={disableSwitchFix} value={true} variant="success">Inclusions</ToggleButton>
                    <ToggleButton disabled={disableSwitchFix} value={false} variant="danger">Exclusions</ToggleButton>
                </ToggleButtonGroup>
            </label>
            <div>
            <label>
                <ToggleButtonGroup
                    type="radio"
                    name="badStock"
                    value={props.isBadStockBool}
                    onChange={() => { props.onToggleBadStock() }}
                    className="mb-3"
                >
                    <ToggleButton disabled={disableSwitchFix} value={false} variant="success">All stock</ToggleButton>
                    <ToggleButton disabled={disableSwitchFix} value={true} variant="danger">Only bad stock</ToggleButton>
                </ToggleButtonGroup>
            </label>
            </div>
            <div>
                <Button variant="secondary" onClick={addInputBoxes}>Add another {props.isInclusion ? "inclusion" : "exclusion"}</Button>
                <Button type="submit">Submit {props.isInclusion ? "Inclusion" : "Exclusion"}</Button>
                {inputValues.length > 1 && <div>Multiple field behaviour is OR</div>}
            </div>
            <div><Button variant="danger" onClick={resetForm}>Reset inclusions/exclusions</Button></div>
        </form>
    );
}

export default InputBoxes;